import React, { FC } from "react"
import { Logo } from "../../../Elements/Logo"
import { Tagline } from "../../../Elements/Tagline"
import Level from "../../Level/Level"
import LevelEnd from "../../Level/LevelEnd"
import LevelStart from "../../Level/LevelStart"
import Copyright from "../Segments/Copyright"
import { FooterLayoutProps } from "../Footer.types"
import FooterLinks from "../Segments/FooterLinks"

const Minimal: FC<FooterLayoutProps> = ({
    links,
    ...props
}: FooterLayoutProps) => {
    return (
        <>
            <Level {...props}>
                <LevelStart>
                    <Logo vertical={true} />
                    <div className="zb-is-hidden-mobile">
                        <Tagline vertical={true} />
                    </div>
                    <div className="zb-is-visible-mobile">
                        <Tagline mobile={true} />
                    </div>
                </LevelStart>
                <LevelEnd>
                    <Level>
                        <FooterLinks links={links} />
                    </Level>
                </LevelEnd>
            </Level>
            <hr />
            <Copyright />
        </>
    )
}

export default Minimal
